import { render, staticRenderFns } from "./FlightsFiltersOptionsSkeleton.vue?vue&type=template&id=5035e4d0"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports